import { useStaticQuery, graphql } from 'gatsby';
import { Query } from '../../../__generated__/gatsby-types';

export const residentialCustomersFAQQuery = graphql`
  {
    allContentfulModuleAccordion(
      filter: { contentful_id: { in: "57ij21ZD9eJSL97Lw9YQUV" } }
    ) {
      nodes {
        node_locale
        accordionHeader
        accordionItems {
          entryName
          tabTitle
          tabBody {
            raw
          }
        }
      }
    }
  }
`;

export default () => {
  const { allContentfulModuleAccordion } = useStaticQuery<Query>(
    residentialCustomersFAQQuery,
  );

  return {
    allContentfulModuleAccordion,
  };
};
